const cssAddress2Reducer = (state = '', action) => {
	switch(action.type){
	case 'CSSADDRESS2VALUE':
		return action.payload;
	default:
		return state;
	}
}

export default cssAddress2Reducer;